const colorCode = {
  // ski
  type1: {
    backgroundColor: '#1EAAFF',
    borderColor: '#1EAAFF'
  },
  // fuss
  type2: {
    backgroundColor: '#FF01EDFF',
    borderColor: '#FF01EDFF'
  },
  // velo
  type3: {
    backgroundColor: '#FF01FF86',
    borderColor: '#FF01FF86'
  },
  // wasser
  type4: {
    backgroundColor: '#f87979',
    borderColor: '#f87979'
  },
  // klett
  type5: {
    backgroundColor: '#ff0086d9',
    borderColor: '#f87979'
  },
  // sport
  type6: {
    backgroundColor: '#ff7f00ff',
    borderColor: '#ff7f00ff'
  },
  typegi: {
    backgroundColor: '#777f00ee',
    borderColor: '#777f00ee'
  },
  typehu: {
    backgroundColor: '#bb7f00dd',
    borderColor: '#bb7f00dd'
  },
  typebst: {
    backgroundColor: '#cc7f00cc',
    borderColor: '#cc7f00cc'
  },
  typetal: {
    backgroundColor: '#dd7f00bb',
    borderColor: '#dd7f00bb'
  },
  typewpt: {
    backgroundColor: '#ee7f00aa',
    borderColor: '#ee7f00aa'
  }
}

export { colorCode }
